import type { ReconLine } from '../../lib/reconciliationApi';

/**
 * Lines that (a) are 'over' after attaching an invoice, (b) were NOT already 'over' before it,
 * and (c) actually contain that invoice. Used to warn — post-attach — that a specific invoice
 * pushed a line past its ordered quantity, with enough detail to name the line and offer undo.
 */
export function invoiceCausedOverLines(
  before: ReconLine[],
  after: ReconLine[],
  invoiceId: string,
): { itemName: string; billedQty: number; orderedQty: number }[] {
  const wasOver = new Set(before.filter((l) => l.status === 'over').map((l) => l.poLineIndex));
  const id = String(invoiceId);
  return after
    .filter(
      (l) =>
        l.status === 'over' &&
        !wasOver.has(l.poLineIndex) &&
        l.matchedInvoices.some((m) => String(m.vendorInvoiceId) === id),
    )
    .map((l) => ({
      itemName: l.itemName || `Line ${l.poLineIndex + 1}`,
      billedQty: l.billedQty,
      orderedQty: l.orderedQty,
    }));
}
